export default __webpack_public_path__ + "static/media/widget_watchbox_vpmes60f_sell.34cbe8b7.mp3";